import React, { useState } from 'react'

import {
	Container,
	CssBaseline,
	makeStyles,
	Card,
	CardContent,
	Toolbar,
	Typography,
	AppBar
} from '@material-ui/core'

import { useHistory } from 'react-router-dom'
import logo from '../../assets/svg/skiptown.svg'

import { showError } from '../../actions/misc/misc.actions'
import { useDispatch, useSelector } from 'react-redux'
import Alert from '../../components/Misc/Alert'

import { isEmailValid } from '../../services/helpers'

const useStyles = makeStyles((theme) => ({
	container: {
		background: '#E5E5E5',
		minHeight: '100vh',
		paddingTop: 144,
		paddingBottom: 16,
		textAlign: 'center',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between'
	},
	appBar: {
		border: 'none'
	},
	toolbar: {
		background: theme.palette.primary.main
	},
	title: {
		fontWeight: 800,
		fontSize: '16px',
		lineHeight: '22px',
		color: '#FFFFFF',
		textTransform: 'uppercase'
	},
	card: {
		maxWidth: 500,
		margin: '0 auto',
		padding: '48px 86px 64px 86px'
	},
	logo: {
		height: 34,
		marginRight: 16
	}
}))

const Login = (props) => {
	const classes = useStyles()
	const history = useHistory()
	const dispatch = useDispatch()

	const alert = useSelector((state) => state.general.main.alert)

	const [isCreateAccountShown, setIsCreateAccountShown] = useState(false)

	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [emailError, setEmailError] = useState(false)
	const [invalidEmailError, setInvalidEmailError] = useState(false)
	const [passwordError, setPasswordError] = useState(false)
	const [wrongPasswordTries, setWrongPasswordTries] = useState(0)

	const updateEmail = (value) => {
		if (emailError) setEmailError(false)

		setInvalidEmailError(value && !isEmailValid(value) ? true : false)

		setEmail(value)
	}

	const updatePassword = (value) => {
		if (passwordError) setPasswordError(false)

		setPassword(value)
	}

	const handleLogin = (e) => {
		if ((e && e.key === 'Enter') || e.type === 'submit') {
			e.stopPropagation()
			let isValid = isLoginValid()

			if (!isValid) {
				return
			}

			props.firebase
				.loginWithEmail(email, password)
				.then(() => {
					history.push('/')
				})
				.catch((e) => {
					let message
					let code = e.code
					let tries = wrongPasswordTries

					if (code && code === 'auth/wrong-password') {
						message = 'The password supplied is incorrect, please try again.'
						setWrongPasswordTries(tries++)
					}

					if (code && code === 'auth/too-many-requests') {
						message = e.message
						setWrongPasswordTries(tries++)
					}

					dispatch(showError(message))
					return
				})
		}
	}

	const isLoginValid = () => {
		let emailValid = isEmailValid(email)

		if (!email || !emailValid) {
			setEmailError(true)
		}

		if (!password) {
			setPasswordError(true)
		}

		return Boolean(email) && Boolean(emailValid) && Boolean(password)
	}

	// const handleSignUp = (e) => {
	//   if ((e && e.key === 'Enter') || e.type ==='submit') {
	//     e.preventDefault();
	//     props
	//       .firebase
	//       .signupWithEmail(email, password)
	//       .then(() => {
	//         history.push('/');
	//       });
	//   }
	// };

	return (
		<Container className={classes.container} component="main" maxWidth={false}>
			<CssBaseline />
			<AppBar position="fixed" className={classes.appBar} color="primary">
				<Toolbar className={classes.toolbar}>
					<img src={logo} alt="Logo" className={classes.logo} />
					<Typography className={classes.title}>Facility Admin</Typography>
				</Toolbar>
			</AppBar>
			<Card className={classes.card}>
				<CardContent style={{ padding: 0 }}>
                    <div>MFA Page</div>
					<Alert {...alert} />
				</CardContent>
			</Card>
			<Typography
				variant="body1"
				style={{
					fontWeight: 600,
					fontSize: '16px',
					lineHeight: '22px'
				}}>
				© 2024 Skipper, Inc. All rights reserved.
			</Typography>
		</Container>
	)
}

export default Login
